
export default {
  aclarationDatepickerTextContainer:{},
  aclarationDatepickerText:{},
  engineDatepickerContainer:{},
  defaultStyle: data => ({
    '&$engineDatepickerContainer':{
      background:'#fff',
      '& > div > div':{
        boxShadow:'none'
      },
      [`@media (min-width: ${data.modalBreak}px)`]: {
        boxShadow: '0 3px 4px 0 rgba(0,0,0,.3)',
        position: 'relative',
      }
    },
    '& $aclarationDatepickerTextContainer':{
      padding:'10px 35px',
      textAlign: 'center',
      position: 'fixed',
      bottom: 0,
      left: '10px',
      right: '10px',
      zIndex: 100,
      background: '#fff',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        padding:'10px 35px 25px',
        position:'static',
        textAlign: 'left',
        '&:lang(ar)': {
          textAlign: 'right',
        }
      },
      '& $aclarationDatepickerText':{
        font: '300 12px/14px '+ data.fontFamily1,
        color:'rgba(187,187,187,.87)'
      },
    },
  }),
  dayText: {
    display:'block',
    font:data =>'500 15px/15px '+ data.fontFamily1
  },
  priceText:{
    display:'block',
    font:data =>'500 9px/16px '+ data.fontFamily1,
    color:'#767676',
    marginLeft:'2px',
    '@media(min-width:951px)':{
      marginLeft:'3px'
    }
  },
  restrictionText:{
    display:'block',
    marginTop:'2px',
  },
  dayContainer:{
    minHeight:'33px',
    '& > div':{
      minHeight:'33px'
    }
  },
  restrictionContainer: data => ({
    padding:'10px 30px 10px 15px',
    background:'#F0F7FF',
    textAlign:'center',
    font: '300 12px/16px '+ data.fontFamily1,
    '& $priceText':{
      marginLeft:'0',
      font: '300 12px/16px '+ data.fontFamily1,
      paddingRight: '10px',
    },
    [`@media (min-width: ${data.modalBreak}px)`]:{
      padding:'10px 25px 10px 15px'
    }
  }),
  priceWithRestriction:{
    '&:before':{
      content:"''",
      position:'absolute',
      left:'0',
      top:'2px',
      width: 0,
      height: 0, 
      borderLeft: '7px solid transparent',
      borderRight: '7px solid transparent',
      borderBottom: data => '7px solid '+data.mainColor,
      transform:'rotate(315deg)'
    }
  },
  hidePrice:{
    '& $dayText':{
      position:'relative',
      paddingBottom:'5px',
      '&:after':{
        content:"''",
        position:'absolute',
        left:'3px',
        bottom:'-5px',
        right: '3px',
        height: '2px', 
        background:data => data.secondColor
      }
    }
  },
  bestPrice:{
    color:data => data.secondColor
  },
  tooltipCalendar:{
    position:'absolute',
    zIndex:900,
    marginTop:'-11px',
    '& > span':{
      marginTop:'-4.5px',
      fontSize:'9px',
      fontWeight:'300'
    }
  },
  displacedCloseButton:{
    '& > span':{
      top:'50%'
    }
  },
  roundedTheme:{
    borderRadius: '25px',
    '& $aclarationDatepickerTextContainer':{
      borderRadius: '0 0 25px 25px'
    }
  },
};